import type { ApprovedFunnelSummary, ProducttypeName } from '@/api/approvedFunnels/types'

/** Ein freigegebener Hauptrichter mit aufgelöstem Anzeigenamen. */
export interface ApprovedFunnelRow {
  readonly producttypeKey: string
  readonly producttypeName: string
  readonly approvedTopicCount: number
  readonly potentialSum: number
}

/**
 * Fügt Aggregat und Anzeigename zusammen.
 *
 * Zwei getrennte Abfragen, weil `producttype_topics` und `producttypes`
 * unterschiedliche Tabellen sind und PostgREST ohne konfigurierte
 * Fremdschlüsselbeziehung nicht eingebettet werden kann. Fehlt ein Name,
 * bleibt der Schlüssel als Anzeige übrig statt eines leeren Feldes.
 */
export function mergeApprovedFunnelNames(
  summaries: readonly ApprovedFunnelSummary[],
  names: readonly ProducttypeName[],
): readonly ApprovedFunnelRow[] {
  const nameByKey = new Map(names.map((entry) => [entry.producttypeKey, entry.producttypeName]))

  return summaries.map((summary) => ({
    producttypeKey: summary.producttypeKey,
    producttypeName: nameByKey.get(summary.producttypeKey) ?? summary.producttypeKey,
    approvedTopicCount: summary.approvedTopicCount,
    potentialSum: summary.potentialSum,
  }))
}

export interface ApprovedFunnelPageTotals {
  readonly approvedTopicCount: number
  readonly potentialSum: number
}

/** Summiert die Kennzahlkacheln über die aktuell geladene Seite. */
export function sumApprovedFunnelRows(
  rows: readonly ApprovedFunnelRow[],
): ApprovedFunnelPageTotals {
  return rows.reduce(
    (totals, row) => ({
      approvedTopicCount: totals.approvedTopicCount + row.approvedTopicCount,
      potentialSum: totals.potentialSum + row.potentialSum,
    }),
    { approvedTopicCount: 0, potentialSum: 0 },
  )
}
